export const useAppStore = defineStore('app', () => {
  const { t } = useI18n()
  const loginVisible = ref(false)
  const loginStep = ref('methods') // 'methods' | 'account' | 'phone'
  const isBindPhoneMode = ref(false)

  const setLoginVisible = (v) => {
    loginVisible.value = v
    if (!v) {
      // 关闭时重置状态
      loginStep.value = 'methods'
      isBindPhoneMode.value = false
    }
  }

  const setLoginStep = (step) => {
    loginStep.value = step
  }

  const setBindPhoneMode = (v) => {
    isBindPhoneMode.value = v
  }

  // 显示绑定手机号页面的快捷方法
  const showBindPhone = () => {
    loginStep.value = 'phone'
    isBindPhoneMode.value = true
    loginVisible.value = true
  }

  const reportLoadingVisible = ref(false)
  const setReportLoadingVisible = (v) => {
    reportLoadingVisible.value = v
  }

  const reportLoadingText = ref(1)
  const setReportLoadingText = (v) => {
    reportLoadingText.value = v
  }

  const reportLoadingPageText = ref([''])
  const setReportLoadingPageText = (v) => {
    const index = v <= 30 ? Math.max(1, Math.ceil(v / 2)) : v === 31 ? 16 : 17

    reportLoadingPageText.value = [t(`fateLoading.m${index}`)]
  }

  const toolbarVisible = ref(true)
  const setToolbarVisible = (v) => {
    toolbarVisible.value = v
  }

  const globalTabbarVisible = ref(true)
  const setGlobalTabbarVisible = (v) => {
    globalTabbarVisible.value = v
  }

  return {
    loginVisible,
    setLoginVisible,
    loginStep,
    setLoginStep,
    isBindPhoneMode,
    setBindPhoneMode,
    showBindPhone,
    reportLoadingVisible,
    setReportLoadingVisible,
    reportLoadingText,
    setReportLoadingText,
    reportLoadingPageText,
    setReportLoadingPageText,
    toolbarVisible,
    setToolbarVisible,
    globalTabbarVisible,
    setGlobalTabbarVisible
  }
})
